import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=af6fbc3e&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af6fbc3e')) {
      api.createRecord('af6fbc3e', component.options)
    } else {
      api.reload('af6fbc3e', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=af6fbc3e&", function () {
      api.rerender('af6fbc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/asideComponent/menuItem.vue"
export default component.exports